


// import React, { useState, useEffect } from 'react';
// import { database, auth } from '../firebase';
// import { ref, onValue, off } from 'firebase/database';
// import { onAuthStateChanged } from 'firebase/auth';
// import ReactDOMServer from 'react-dom/server';

// // Helper: Extract city from address
// const getCityFromAddress = (address) => {
//   if (!address) return 'Unknown City';
//   const addressParts = address.trim().split(/\s+/);
//   return addressParts.length > 0 ? addressParts[addressParts.length - 1] : 'Unknown City';
// };

// // Filter Section Component
// const FilterSection = ({ title, options, selected, onChange }) => {
//   const handleCheckboxChange = (option) => {
//     if (option === options[0]) {
//       onChange(selected.includes(option) ? [] : [...options]);
//     } else {
//       const newSelected = selected.includes(option)
//         ? selected.filter(item => item !== option && item !== options[0])
//         : [...selected.filter(item => item !== options[0]), option];
//       onChange(newSelected.length === options.length - 1 ? [options[0], ...newSelected] : newSelected);
//     }
//   };

//   return (
//     <div style={{
//       backgroundColor: '#f8fafc',
//       padding: '16px',
//       borderRadius: '8px',
//       border: '1px solid #e2e8f0',
//       boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
//       transition: 'all 0.3s ease',
//       maxWidth: '220px',
//       marginBottom: '16px',
//     }}>
//       <h2 style={{
//         fontSize: '16px',
//         fontWeight: '600',
//         color: '#1e293b',
//         marginBottom: '8px',
//         borderBottom: '2px solid #3b82f6',
//         paddingBottom: '6px',
//       }}>{title}</h2>
//       <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//         {options.map((option) => (
//           <label key={option} style={{ 
//             display: 'flex', 
//             alignItems: 'center', 
//             gap: '8px',
//             cursor: 'pointer',
//             padding: '6px',
//             borderRadius: '6px',
//             transition: 'background-color 0.2s',
//             backgroundColor: selected.includes(option) ? '#eff6ff' : 'transparent',
//           }}
//           onMouseEnter={(e) => !selected.includes(option) && (e.currentTarget.style.backgroundColor = '#f1f5f9')}
//           onMouseLeave={(e) => !selected.includes(option) && (e.currentTarget.style.backgroundColor = 'transparent')}>
//             <input
//               type="checkbox"
//               checked={selected.includes(option)}
//               onChange={() => handleCheckboxChange(option)}
//               style={{
//                 height: '14px',
//                 width: '14px',
//                 accentColor: '#3b82f6',
//                 cursor: 'pointer',
//               }}
//             />
//             <span style={{ 
//               fontSize: '14px',
//               color: '#475569',
//               userSelect: 'none',
//               fontWeight: selected.includes(option) ? '500' : '400',
//             }}>{option}</span>
//           </label>
//         ))}
//       </div>
//     </div>
//   );
// };

// // Sales Return Report Display Component
// const SalesReturnReportDisplay = ({ formData, filters, branchProfile, salesReturnData }) => {
//   const parseReturnDate = (dateString) => {
//     if (!dateString) return null;
//     if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
//       const parts = dateString.split('-');
//       return new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
//     }
//     if (/^\d{2}[-\/]\d{2}[-\/]\d{4}$/.test(dateString)) {
//       const parts = dateString.split(/[-\/]/);
//       return new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
//     }
//     return new Date(dateString);
//   };

//   const formatDisplayDate = (dateString) => {
//     const date = parseReturnDate(dateString);
//     return !date || isNaN(date.getTime()) ? 'N/A' : date.toLocaleDateString('en-GB', {
//       day: '2-digit',
//       month: '2-digit',
//       year: 'numeric'
//     });
//   };

//   let filteredSalesReturnData = salesReturnData;

//   if (!filters.store.includes("All Stores")) {
//     filteredSalesReturnData = filteredSalesReturnData.filter(item => filters.store.includes(item.store));
//   }
//   if (!filters.customer.includes("All Customers")) {
//     filteredSalesReturnData = filteredSalesReturnData.filter(item => filters.customer.includes(item.customer));
//   }
//   if (!filters.group.includes("All Group Names")) {
//     filteredSalesReturnData = filteredSalesReturnData.filter(item => filters.group.includes(item.groupName));
//   }
//   if (!filters.category.includes("All Categories")) {
//     filteredSalesReturnData = filteredSalesReturnData.filter(item => filters.category.includes(item.category));
//   }
//   if (!filters.brand.includes("All Brands")) {
//     filteredSalesReturnData = filteredSalesReturnData.filter(item => filters.brand.includes(item.brand));
//   }
//   if (!filters.product.includes("All Products")) {
//     filteredSalesReturnData = filteredSalesReturnData.filter(item => filters.product.includes(item.itemDescription));
//   }

//   const filterByDateRange = (data) => {
//     return data.filter(item => {
//       const itemDate = parseReturnDate(item.srnDate);
//       if (!itemDate || isNaN(itemDate.getTime())) return false;
//       const fromDate = new Date(formData.fromDate);
//       const toDate = new Date(formData.toDate);
//       toDate.setHours(23, 59, 59, 999);
//       return itemDate >= fromDate && itemDate <= toDate;
//     });
//   };

//   const getReportTitle = () => {
//     switch (formData.searchBy) {
//       case "datewise": return "Datewise Sales Return Report";
//       case "store": return "Store-wise Sales Return Report";
//       case "customer": return "Customerwise Sales Return Report";
//       case "salesmanwise": return "SalesRep wise Sales Return Report";
//       case "groupwise": return "Groupwise Sales Return Report";
//       case "category": return "Category-wise Sales Return Report";
//       case "brand": return "Brand-wise Sales Return Report";
//       case "productwise": return "Product-wise Sales Return Report";
//       default: return "Datewise Sales Return Report";
//     }
//   };

//   const city = branchProfile.city || getCityFromAddress(branchProfile.address);

//   const dateFilteredData = filterByDateRange(filteredSalesReturnData);

//   const renderDetailedReport = () => {
//     if (formData.searchBy === "datewise") {
//       const grandTotal = dateFilteredData.reduce((sum, item) => sum + item.totalValue, 0);
//       return (
//         <div style={{ overflowX: 'auto' }}>
//           <table style={{ 
//   width: '100%', 
//   borderCollapse: 'collapse', 
//   fontSize: '11px', 
//   border: '2px solid #3b82f6',
//   borderRadius: '8px',
//   overflow: 'hidden',
//   boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
// }} className="datewise-detailed">
//             <thead>
//               <tr style={{ backgroundColor: '#f1f5f9', borderBottom: '2px solid #3b82f6' }}>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>S.No</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Inv.No</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Inv.Dt</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Customer</th>

//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Product Name</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Qty</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Rate</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Gross Amnt</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Disc Amnt</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>CGST Amnt</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>SGST Amnt</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>GST Amnt</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Net Value</th>
//               </tr>
//             </thead>
//             <tbody>
//               {dateFilteredData.length === 0 ? (
//                 <tr>
//                   <td colSpan="14" style={{ 
//                     border: '1px solid #cbd5e1', 
//                     padding: '30px', 
//                     textAlign: 'center', 
//                     color: '#64748b', 
//                     fontStyle: 'italic',
//                     fontSize: '14px',
//                     backgroundColor: '#f8fafc'
//                   }}>
//                     No sales return data found for the selected criteria
//                   </td>
//                 </tr>
//               ) : (
//                 <>
//                   {dateFilteredData.map((item, index) => (
//                     <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{index + 1}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{item.srnNo}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{formatDisplayDate(item.srnDate)}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'left', fontSize: '11px' }}>{item.customer}</td>

//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'left', fontSize: '11px' }}>{item.itemDescription}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{item.qty}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.mrp.toFixed(2)}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{(item.qty * item.mrp).toFixed(2)}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.discount.toFixed(2)}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.cgstTax.toFixed(2)}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.sgstTax.toFixed(2)}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{(item.cgstTax + item.sgstTax).toFixed(2)}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.totalValue.toFixed(2)}</td>
//                     </tr>
//                   ))}
//                   <tr style={{ backgroundColor: '#f1f5f9', fontWeight: '600' }}>
//                     <td colSpan="12" style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>Bill Grand Total:</td>
//                     <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{grandTotal.toFixed(2)}</td>
//                   </tr>
//                   <tr style={{ backgroundColor: '#f1f5f9', fontWeight: '600' }}>
//                     <td colSpan="12" style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>Total:</td>
//                     <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{grandTotal.toFixed(2)}</td>
//                   </tr>
//                 </>
//               )}
//             </tbody>
//           </table>
//         </div>
//       );
//     } else if (formData.searchBy === "customer") {
//       const grandTotal = dateFilteredData.reduce((sum, item) => sum + item.totalValue, 0);
//       return (
//         <div style={{ overflowX: 'auto' }}>
//         <table style={{ 
//   width: '100%', 
//   borderCollapse: 'collapse', 
//   fontSize: '11px', 
//   border: '2px solid #3b82f6',
//   borderRadius: '8px',
//   overflow: 'hidden',
//   boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
// }} className="customer-detailed">
//             <thead>
//               <tr style={{ backgroundColor: '#f1f5f9', borderBottom: '2px solid #3b82f6' }}>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>S.No</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>INV.No</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>INV.Dt</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Gross Amnt</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Disc Amnt</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>CGST Amnt</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>SGST Amnt</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>GST Amnt</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Others</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Net Value</th>
//               </tr>
//             </thead>
//             <tbody>
//               {dateFilteredData.length === 0 ? (
//                 <tr>
//                   <td colSpan="10" style={{ 
//                     border: '1px solid #cbd5e1', 
//                     padding: '30px', 
//                     textAlign: 'center', 
//                     color: '#64748b', 
//                     fontStyle: 'italic',
//                     fontSize: '14px',
//                     backgroundColor: '#f8fafc'
//                   }}>
//                     No sales return data found for the selected criteria
//                   </td>
//                 </tr>
//               ) : (
//                 <>
//                   {dateFilteredData.map((item, index) => (
//                     <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{index + 1}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{item.srnNo}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{formatDisplayDate(item.srnDate)}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{(item.qty * item.mrp).toFixed(2)}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.discount.toFixed(2)}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.cgstTax.toFixed(2)}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.sgstTax.toFixed(2)}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{(item.cgstTax + item.sgstTax).toFixed(2)}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹0.00</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.totalValue.toFixed(2)}</td>
//                     </tr>
//                   ))}
//                   <tr style={{ backgroundColor: '#f1f5f9', fontWeight: '600' }}>
//                     <td colSpan="9" style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>Bill Grand Total:</td>
//                     <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{grandTotal.toFixed(2)}</td>
//                   </tr>
//                   <tr style={{ backgroundColor: '#f1f5f9', fontWeight: '600' }}>
//                     <td colSpan="9" style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>Total:</td>
//                     <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{grandTotal.toFixed(2)}</td>
//                   </tr>
//                 </>
//               )}
//             </tbody>
//           </table>
//         </div>
//       );
//     } else if (formData.searchBy === "salesmanwise") {
//       const grandTotal = dateFilteredData.reduce((sum, item) => sum + item.totalValue, 0);
//       return (
//         <div style={{ overflowX: 'auto' }}>
//      <table style={{ 
//   width: '100%', 
//   borderCollapse: 'collapse', 
//   fontSize: '11px', 
//   border: '2px solid #3b82f6',
//   borderRadius: '8px',
//   overflow: 'hidden',
//   boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
// }} className="groupwise-abstract">
//             <thead>
//               <tr style={{ backgroundColor: '#f1f5f9', borderBottom: '2px solid #3b82f6' }}>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>S.No</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>INV.No</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>INV.Dt</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Customer Name</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Gross Amt</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Disc.Amt</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>CGST Amnt</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>SGST Amnt</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>GST Amnt</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Others</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Net Value</th>
//               </tr>
//             </thead>
//             <tbody>
//               {dateFilteredData.length === 0 ? (
//                 <tr>
//                   <td colSpan="11" style={{ 
//                     border: '1px solid #cbd5e1', 
//                     padding: '30px', 
//                     textAlign: 'center', 
//                     color: '#64748b', 
//                     fontStyle: 'italic',
//                     fontSize: '14px',
//                     backgroundColor: '#f8fafc'
//                   }}>
//                     No sales return data found for the selected criteria
//                   </td>
//                 </tr>
//               ) : (
//                 <>
//                   {dateFilteredData.map((item, index) => (
//                     <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{index + 1}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{item.srnNo}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{formatDisplayDate(item.srnDate)}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'left', fontSize: '11px' }}>{item.customer}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{(item.qty * item.mrp).toFixed(2)}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.discount.toFixed(2)}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.cgstTax.toFixed(2)}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.sgstTax.toFixed(2)}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{(item.cgstTax + item.sgstTax).toFixed(2)}</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹0.00</td>
//                       <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.totalValue.toFixed(2)}</td>
//                     </tr>
//                   ))}
//                   <tr style={{ backgroundColor: '#f1f5f9', fontWeight: '600' }}>
//                     <td colSpan="10" style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>Bill Grand Total:</td>
//                     <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{grandTotal.toFixed(2)}</td>
//                   </tr>
//                   <tr style={{ backgroundColor: '#f1f5f9', fontWeight: '600' }}>
//                     <td colSpan="10" style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>Total:</td>
//                     <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{grandTotal.toFixed(2)}</td>
//                   </tr>
//                 </>
//               )}
//             </tbody>
//           </table>
//         </div>
//       );
//     }
//   };

//   const renderAbstractReport = () => {
//     if (formData.searchBy === "groupwise") {
//       const groupedData = dateFilteredData.reduce((acc, item) => {
//         const groupName = item.groupName || 'No Group Assigned';
//         if (!acc[groupName]) {
//           acc[groupName] = { groupName, value: 0, discount: 0, gstValue: 0, netValue: 0 };
//         }
//         acc[groupName].value += item.value;
//         acc[groupName].discount += item.discount;
//         acc[groupName].gstValue += (item.cgstTax + item.sgstTax);
//         acc[groupName].netValue += item.totalValue;
//         return acc;
//       }, {});

//       const groupedArray = Object.values(groupedData);

//       return (
//         <div style={{ overflowX: 'auto' }}>
//           <table style={{ 
//             width: '100%', 
//             borderCollapse: 'collapse', 
//             fontSize: '11px', 
//             border: '2px solid #3b82f6',
//             borderRadius: '8px',
//             overflow: 'hidden',
//             boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
//           }}>
//             <thead>
//               <tr style={{ backgroundColor: '#f1f5f9', borderBottom: '2px solid #3b82f6' }}>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>S.No</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Group Name</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Value</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Disc.</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>GST Value</th>
//                 <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Net Value</th>
//               </tr>
//             </thead>
//             <tbody>
//               {groupedArray.length === 0 ? (
//                 <tr>
//                   <td colSpan="6" style={{ 
//                     border: '1px solid #cbd5e1', 
//                     padding: '30px', 
//                     textAlign: 'center', 
//                     color: '#64748b', 
//                     fontStyle: 'italic',
//                     fontSize: '14px',
//                     backgroundColor: '#f8fafc'
//                   }}>
//                     No Record Found.
//                   </td>
//                 </tr>
//               ) : (
//                 groupedArray.map((item, index) => (
//                   <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
//                     <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{index + 1}</td>
//                     <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'left', fontSize: '11px' }}>{item.groupName}</td>
//                     <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.value.toFixed(2)}</td>
//                     <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.discount.toFixed(2)}</td>
//                     <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.gstValue.toFixed(2)}</td>
//                     <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.netValue.toFixed(2)}</td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//       );
//     }
//   };

//   return (
//     <div style={{
//       backgroundColor: 'white',
//       padding: '30px',
//       marginTop: '20px',
//       border: '2px solid #3b82f6',
//       borderRadius: '12px',
//       fontFamily: 'Arial, sans-serif',
//       fontSize: '12px',
//       pageBreakInside: 'avoid',
//       boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
//     }} className="print-only">
//       <div style={{ 
//         display: 'flex', 
//         justifyContent: 'space-between', 
//         alignItems: 'flex-start', 
//         marginBottom: '30px',
//         paddingBottom: '20px',
//         borderBottom: '2px solid #e2e8f0'
//       }}>
//         <div style={{ flex: 1 }}>
//           <h1 style={{ 
//             fontSize: '24px', 
//             fontWeight: 'bold', 
//             margin: '0', 
//             marginBottom: '15px',
//             color: '#1e293b',
//             textShadow: '1px 1px 2px rgba(0,0,0,0.1)'
//           }}>
//             {branchProfile.branchName}
//           </h1>
//           <div style={{ fontSize: '14px', lineHeight: '1.6', color: '#475569' }}>
//             <div style={{ marginBottom: '8px', fontSize: '16px', fontWeight: '600', color: '#3b82f6' }}>
//               {getReportTitle()}
//             </div>
//             <div style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
//               <span><strong>From:</strong> {new Date(formData.fromDate).toLocaleDateString('en-GB')}</span>
//               <span><strong>To:</strong> {new Date(formData.toDate).toLocaleDateString('en-GB')}</span>
//             </div>
//           </div>
//         </div>
//         <div style={{
//           background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
//           color: 'white',
//           padding: '15px 25px',
//           borderRadius: '15px',
//           textAlign: 'center',
//           minWidth: '150px',
//           boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
//         }}>
//           <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{city}</div>
//           <div style={{ fontSize: '12px', marginTop: '5px', opacity: '0.9' }}>
//             Option: {formData.reportType === 'detailed' ? 'Detail' : 'Abstract'}
//           </div>
//         </div>
//       </div>
//       {formData.reportType === 'detailed' ? renderDetailedReport() : renderAbstractReport()}
//     </div>
//   );
// };

// // Main Sales Return Report Generator Component
// const SalesReturnReport = () => {
//   const today = new Date();
//   const [fromDate, setFromDate] = useState(today.toISOString().split('T')[0]);
//   const [toDate, setToDate] = useState(today.toISOString().split('T')[0]);
//   const [searchBy, setSearchBy] = useState("salesmanwise");
//   const [reportType, setReportType] = useState("detailed");
//   const [filters, setFilters] = useState({
//     store: ["All Stores"],
//     customer: ["All Customers"],
//     group: ["All Group Names"],
//     category: ["All Categories"],
//     brand: ["All Brands"],
//     product: ["All Products"]
//   });
//   const [stores, setStores] = useState(["All Stores"]);
//   const [customers, setCustomers] = useState(["All Customers"]);
//   const [groups, setGroups] = useState(["All Group Names"]);
//   const [categories, setCategories] = useState(["All Categories"]);
//   const [brands, setBrands] = useState(["All Brands"]);
//   const [products, setProducts] = useState(["All Products"]);
//   const [currentUser, setCurrentUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [showReport, setShowReport] = useState(false);
//   const [branchProfile, setBranchProfile] = useState({
//     branchName: "SUPREME TRADERS",
//     address: "",
//     phone: "",
//     city: ""
//   });
//   const [salesReturnData, setSalesReturnData] = useState([]);
//   const [productGroupMap, setProductGroupMap] = useState({});
//   const [productCategoryMap, setProductCategoryMap] = useState({});
//   const [productBrandMap, setProductBrandMap] = useState({});

//   const encodeEmailForPath = (email) => {
//     return email.replace(/[.#$[\]]/g, '_');
//   };

//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       setCurrentUser(user);
//       if (user) loadFirebaseData(user);
//       setLoading(false);
//     });
//     return () => unsubscribe();
//   }, []);

//   const loadFirebaseData = (user) => {
//     const encodedEmail = encodeEmailForPath(user.email);

//     const branchProfileRef = ref(database, `users/${encodedEmail}/branchProfiles`);
//     onValue(branchProfileRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const profiles = Object.values(data);
//         const latestProfile = profiles[profiles.length - 1];
//         setBranchProfile({
//           branchName: latestProfile.branchName || "SUPREME TRADERS",
//           address: `${latestProfile.address1 || ''} ${latestProfile.address2 || ''}`.trim(),
//           phone: latestProfile.mobileNo || '',
//           city: latestProfile.city || getCityFromAddress(`${latestProfile.address1 || ''} ${latestProfile.address2 || ''}`)
//         });
//       }
//     });

//     const storesRef = ref(database, `users/${encodedEmail}/stores`);
//     onValue(storesRef, (snapshot) => {
//       const storesData = ["All Stores"];
//       if (snapshot.exists()) snapshot.forEach((childSnapshot) => {
//         const store = childSnapshot.val();
//         if (store.name && !storesData.includes(store.name)) storesData.push(store.name);
//       });
//       setStores(storesData);
//     });

//     const customersRef = ref(database, `users/${encodedEmail}/customers`);
//     onValue(customersRef, (snapshot) => {
//       const customersData = ["All Customers"];
//       if (snapshot.exists()) snapshot.forEach((childSnapshot) => {
//         const customer = childSnapshot.val();
//         if (customer.customerName && !customersData.includes(customer.customerName)) customersData.push(customer.customerName);
//       });
//       setCustomers(customersData);
//     });

//     const groupsRef = ref(database, `users/${encodedEmail}/productGroups`);
//     onValue(groupsRef, (snapshot) => {
//       const groupsData = ["All Group Names"];
//       if (snapshot.exists()) snapshot.forEach((childSnapshot) => {
//         const group = childSnapshot.val();
//         if (group.name && !groupsData.includes(group.name)) groupsData.push(group.name);
//       });
//       setGroups(groupsData);
//     });

//     const categoriesRef = ref(database, `users/${encodedEmail}/categories`);
//     onValue(categoriesRef, (snapshot) => {
//       const categoriesData = ["All Categories"];
//       if (snapshot.exists()) snapshot.forEach((childSnapshot) => {
//         const category = childSnapshot.val();
//         if (category.name && !categoriesData.includes(category.name)) categoriesData.push(category.name);
//       });
//       setCategories(categoriesData);
//     });

//     const brandsRef = ref(database, `users/${encodedEmail}/brands`);
//     onValue(brandsRef, (snapshot) => {
//       const brandsData = ["All Brands"];
//       if (snapshot.exists()) snapshot.forEach((childSnapshot) => {
//         const brand = childSnapshot.val();
//         if (brand.name && !brandsData.includes(brand.name)) brandsData.push(brand.name);
//       });
//       setBrands(brandsData);
//     });

//     const productsRef = ref(database, `users/${encodedEmail}/products`);
//     onValue(productsRef, (snapshot) => {
//       const productsData = ["All Products"];
//       const groupMap = {};
//       const categoryMap = {};
//       const brandMap = {};
//       if (snapshot.exists()) snapshot.forEach((childSnapshot) => {
//         const product = childSnapshot.val();
//         if (product.productName && !productsData.includes(product.productName)) {
//           productsData.push(product.productName);
//           groupMap[product.productName] = product.groupName || product.group || 'No Group Assigned';
//           categoryMap[product.productName] = product.category || 'Unknown Category';
//           brandMap[product.productName] = product.brand || 'Unknown Brand';
//         }
//       });
//       setProducts(productsData);
//       setProductGroupMap(groupMap);
//       setProductCategoryMap(categoryMap);
//       setProductBrandMap(brandMap);
//     });

//     const salesReturnsRef = ref(database, `users/${encodedEmail}/salesReturns`);
//     onValue(salesReturnsRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const returnRecords = [];
//         Object.entries(data).forEach(([returnId, returnData]) => {
//           if (returnData.items && Array.isArray(returnData.items)) {
//             returnData.items.forEach(item => {
//               if (item.itemDescription) {
//                 const qty = parseFloat(item.qty) || 0;
//                 const mrp = parseFloat(item.mrp) || 0;
//                 const discPercent = parseFloat(item.disc) || 0;
//                 const cgstRate = parseFloat(item.cgst) || 0;
//                 const sgstRate = parseFloat(item.sgst) || 0;
//                 const baseAmount = qty * mrp;
//                 const discount = (baseAmount * discPercent) / 100;
//                 const value = baseAmount - discount;
//                 const cgstTax = (value * cgstRate) / 100;
//                 const sgstTax = (value * sgstRate) / 100;
//                 const totalValue = value + cgstTax + sgstTax;

//                 returnRecords.push({
//                   returnId,
//                   srnNo: returnData.srnNo || 'N/A',
//                   srnDate: returnData.srnDate || '',
//                   billNo: returnData.billNo || 'N/A',
//                   store: returnData.store || 'Unknown Store',
//                   customer: returnData.customer || 'Unknown Customer',
//                   itemDescription: item.itemDescription || 'Unknown Product',
//                   groupName: productGroupMap[item.itemDescription] || 'No Group Assigned',
//                   category: productCategoryMap[item.itemDescription] || 'Unknown Category',
//                   brand: productBrandMap[item.itemDescription] || 'Unknown Brand',
//                   barCode: item.barCode || '',
//                   uom: item.uom || '',
//                   qty,
//                   mrp,
//                   value,
//                   discount,
//                   cgstTax,
//                   sgstTax,
//                   totalValue
//                 });
//               }
//             });
//           }
//         });
//         setSalesReturnData(returnRecords);
//       } else {
//         setSalesReturnData([]);
//       }
//     });

//     return () => {
//       off(branchProfileRef);
//       off(storesRef);
//       off(customersRef);
//       off(groupsRef);
//       off(categoriesRef);
//       off(brandsRef);
//       off(productsRef);
//       off(salesReturnsRef);
//     };
//   };

//   useEffect(() => {
//     if (Object.keys(productGroupMap).length > 0 && currentUser) {
//       setSalesReturnData(prevData => 
//         prevData.map(item => ({
//           ...item,
//           groupName: productGroupMap[item.itemDescription] || 'No Group Assigned',
//           category: productCategoryMap[item.itemDescription] || 'Unknown Category',
//           brand: productBrandMap[item.itemDescription] || 'Unknown Brand'
//         }))
//       );
//     }
//   }, [productGroupMap, productCategoryMap, productBrandMap, currentUser]);

//   const handleFilterChange = (key, value) => {
//     setFilters({ ...filters, [key]: value });
//   };

//   const handleGenerateReport = () => {
//     setShowReport(true);
//   };

// const handlePrint = () => {
//   const printContent = (
//     <SalesReturnReportDisplay 
//       formData={{ fromDate, toDate, searchBy, reportType }}
//       filters={filters}
//       branchProfile={branchProfile}
//       salesReturnData={salesReturnData}
//     />
//   );

//   const htmlString = ReactDOMServer.renderToString(printContent);

//   const printWindow = window.open('', '', 'width=1200,height=800');
//   printWindow.document.write(`
//     <html>
//       <head>
//         <title>Sales Return Report</title>
//         <style>
//           body { 
//             margin: 0; 
//             padding: 5px; 
//             font-family: Arial, sans-serif; 
//             font-size: 8px;
//           }
//           @page { 
//             size: A4 landscape; 
//             margin: 5mm; 
//           }
//           table { 
//             page-break-inside: auto;
//             width: 100%;
//             font-size: 7px;
//             table-layout: fixed;
//             border-collapse: collapse;
//           }
//           tr { 
//             page-break-inside: avoid; 
//             page-break-after: auto; 
//           }
//           th, td {
//                 padding: 4px !important;
//             font-size: 12px !important;
//             white-space: nowrap;
//             overflow: hidden;
//             text-overflow: ellipsis;
//             max-width: 60px;
//           }
          
//           /* Datewise detailed columns */
//           .datewise-detailed th:nth-child(1), .datewise-detailed td:nth-child(1) { width: 25px; } /* S.No */
//           .datewise-detailed th:nth-child(2), .datewise-detailed td:nth-child(2) { width: 45px; } /* Inv No */
//           .datewise-detailed th:nth-child(3), .datewise-detailed td:nth-child(3) { width: 40px; } /* Date */
//           .datewise-detailed th:nth-child(4), .datewise-detailed td:nth-child(4) { width: 60px; } /* Customer */
//           .datewise-detailed th:nth-child(5), .datewise-detailed td:nth-child(5) { width: 40px; } /* BarCode */
//           .datewise-detailed th:nth-child(6), .datewise-detailed td:nth-child(6) { width: 80px; } /* Product */
//           .datewise-detailed th:nth-child(7), .datewise-detailed td:nth-child(7) { width: 30px; } /* Qty */
//           .datewise-detailed th:nth-child(8), .datewise-detailed td:nth-child(8) { width: 35px; } /* Rate */
//           .datewise-detailed th:nth-child(9), .datewise-detailed td:nth-child(9) { width: 40px; } /* Gross */
//           .datewise-detailed th:nth-child(10), .datewise-detailed td:nth-child(10) { width: 40px; } /* Disc */
//           .datewise-detailed th:nth-child(11), .datewise-detailed td:nth-child(11) { width: 40px; } /* CGST */
//           .datewise-detailed th:nth-child(12), .datewise-detailed td:nth-child(12) { width: 40px; } /* SGST */
//           .datewise-detailed th:nth-child(13), .datewise-detailed td:nth-child(13) { width: 40px; } /* GST */
//           .datewise-detailed th:nth-child(14), .datewise-detailed td:nth-child(14) { width: 50px; } /* Net Value */

//           /* Customer detailed columns */
//           .customer-detailed th:nth-child(1), .customer-detailed td:nth-child(1) { width: 30px; } /* S.No */
//           .customer-detailed th:nth-child(2), .customer-detailed td:nth-child(2) { width: 50px; } /* INV No */
//           .customer-detailed th:nth-child(3), .customer-detailed td:nth-child(3) { width: 45px; } /* Date */
//           .customer-detailed th:nth-child(4), .customer-detailed td:nth-child(4) { width: 50px; } /* Gross */
//           .customer-detailed th:nth-child(5), .customer-detailed td:nth-child(5) { width: 45px; } /* Disc */
//           .customer-detailed th:nth-child(6), .customer-detailed td:nth-child(6) { width: 45px; } /* CGST */
//           .customer-detailed th:nth-child(7), .customer-detailed td:nth-child(7) { width: 45px; } /* SGST */
//           .customer-detailed th:nth-child(8), .customer-detailed td:nth-child(8) { width: 45px; } /* GST */
//           .customer-detailed th:nth-child(9), .customer-detailed td:nth-child(9) { width: 40px; } /* Others */
//           .customer-detailed th:nth-child(10), .customer-detailed td:nth-child(10) { width: 55px; } /* Net Value */

//           /* Salesmanwise detailed columns */
//           .salesmanwise-detailed th:nth-child(1), .salesmanwise-detailed td:nth-child(1) { width: 25px; } /* S.No */
//           .salesmanwise-detailed th:nth-child(2), .salesmanwise-detailed td:nth-child(2) { width: 45px; } /* INV No */
//           .salesmanwise-detailed th:nth-child(3), .salesmanwise-detailed td:nth-child(3) { width: 40px; } /* Date */
//           .salesmanwise-detailed th:nth-child(4), .salesmanwise-detailed td:nth-child(4) { width: 60px; } /* Customer */
//           .salesmanwise-detailed th:nth-child(5), .salesmanwise-detailed td:nth-child(5) { width: 45px; } /* Gross */
//           .salesmanwise-detailed th:nth-child(6), .salesmanwise-detailed td:nth-child(6) { width: 40px; } /* Disc */
//           .salesmanwise-detailed th:nth-child(7), .salesmanwise-detailed td:nth-child(7) { width: 40px; } /* CGST */
//           .salesmanwise-detailed th:nth-child(8), .salesmanwise-detailed td:nth-child(8) { width: 40px; } /* SGST */
//           .salesmanwise-detailed th:nth-child(9), .salesmanwise-detailed td:nth-child(9) { width: 40px; } /* GST */
//           .salesmanwise-detailed th:nth-child(10), .salesmanwise-detailed td:nth-child(10) { width: 35px; } /* Others */
//           .salesmanwise-detailed th:nth-child(11), .salesmanwise-detailed td:nth-child(11) { width: 50px; } /* Net Value */

//           /* Groupwise abstract columns */
//           .groupwise-abstract th:nth-child(1), .groupwise-abstract td:nth-child(1) { width: 30px; } /* S.No */
//           .groupwise-abstract th:nth-child(2), .groupwise-abstract td:nth-child(2) { width: 120px; } /* Group */
//           .groupwise-abstract th:nth-child(3), .groupwise-abstract td:nth-child(3) { width: 50px; } /* Value */
//           .groupwise-abstract th:nth-child(4), .groupwise-abstract td:nth-child(4) { width: 45px; } /* Disc */
//           .groupwise-abstract th:nth-child(5), .groupwise-abstract td:nth-child(5) { width: 50px; } /* GST Value */
//           .groupwise-abstract th:nth-child(6), .groupwise-abstract td:nth-child(6) { width: 60px; } /* Net Value */
          
//           .print-only {
//             width: 93% !important;
//             max-width: none !important;
//             overflow: visible !important;
//           }
//           div[style*="overflowX"] {
//             overflow: visible !important;
//           }
//         </style>
//       </head>
//       <body>
//         <div id="print-content">${htmlString}</div>
//         <script>
//           setTimeout(function() {
//             window.print();
//             window.close();
//           }, 1000);
//         </script>
//       </body>
//     </html>
//   `);
//   printWindow.document.close();
// };

//   const formData = {
//     fromDate,
//     toDate,
//     searchBy,
//     reportType
//   };

//   const getReportTypeOptions = () => {
//     switch (searchBy) {
//       case "groupwise":
//       case "productwise":
//         return ["abstract"];
//       case "customer":
//       case "datewise":
//       case "salesmanwise":
//         return ["detailed", "abstract"];
//       default:
//         return ["detailed", "abstract"];
//     }
//   };

//   if (loading) {
//     return (
//       <div style={{ 
//         display: 'flex', 
//         justifyContent: 'center', 
//         alignItems: 'center', 
//         height: '400px',
//         fontSize: '18px',
//         color: '#64748b',
//         backgroundColor: '#f8fafc',
//         borderRadius: '12px',
//         border: '1px solid #e2e8f0'
//       }}>
//         <div style={{ textAlign: 'center' }}>
//           <div style={{ 
//             width: '40px', 
//             height: '40px', 
//             border: '4px solid #e2e8f0',
//             borderTop: '4px solid #3b82f6',
//             borderRadius: '50%',
//             animation: 'spin 1s linear infinite',
//             margin: '0 auto 16px'
//           }}></div>
//           <div>Loading Sales Return Data...</div>
//         </div>
//       </div>
//     );
//   }

//   if (!currentUser) {
//     return (
//       <div style={{ 
//         textAlign: 'center', 
//         padding: '3rem', 
//         color: '#64748b', 
//         fontSize: '18px',
//         backgroundColor: '#f8fafc',
//         borderRadius: '12px',
//         border: '1px solid #e2e8f0'
//       }}>
//         <h2 style={{ color: '#1e293b', marginBottom: '16px' }}>Authentication Required</h2>
//         <p>Please login to access the Sales Return Report </p>
//       </div>
//     );
//   }

//   return (
//     <div style={{
//       width: '100%',
//       maxWidth: '90rem',
//       backgroundColor: 'white',
//       borderRadius: '16px',
//       boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
//       padding: '32px',
//       margin: '0 auto',
//       fontFamily: 'system-ui, -apple-system, sans-serif',
//       border: '1px solid #e2e8f0'
//     }}>
//       <style>
//         {`
//           @keyframes spin {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
//         `}
//       </style>
      
//       <div style={{ 
//         display: 'flex', 
//         alignItems: 'center', 
//         gap: '12px',
//         marginBottom: '24px',
//         paddingBottom: '16px',
//         borderBottom: '2px solid #e2e8f0'
//       }}>
//         <div style={{
//           width: '6px',
//           height: '32px',
//           backgroundColor: '#3b82f6',
//           borderRadius: '3px'
//         }}></div>
//         <h1 style={{
//           fontSize: '28px',
//           fontWeight: '700',
//           color: '#1e293b',
//           margin: '0'
//         }}>Sales Return Report </h1>
//       </div>
      
//       <div style={{
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
//         gap: '20px',
//         marginBottom: '32px',
//         padding: '24px',
//         backgroundColor: '#f8fafc',
//         borderRadius: '12px',
//         border: '1px solid #e2e8f0'
//       }}>
//         <div>
//           <label style={{
//             display: 'block',
//             fontSize: '14px',
//             fontWeight: '600',
//             color: '#374151',
//             marginBottom: '8px'
//           }}>From Date</label>
//           <input
//             type="date"
//             value={fromDate}
//             onChange={(e) => setFromDate(e.target.value)}
//             style={{
//               width: '100%',
//               padding: '12px 16px',
//               border: '1px solid #d1d5db',
//               borderRadius: '8px',
//               fontSize: '14px',
//               outline: 'none',
//               transition: 'all 0.2s',
//               boxSizing: 'border-box',
//               backgroundColor: 'white'
//             }}
//             onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
//             onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
//           />
//         </div>
//         <div>
//           <label style={{
//             display: 'block',
//             fontSize: '14px',
//             fontWeight: '600',
//             color: '#374151',
//             marginBottom: '8px'
//           }}>To Date</label>
//           <input
//             type="date"
//             value={toDate}
//             onChange={(e) => setToDate(e.target.value)}
//             style={{
//               width: '100%',
//               padding: '12px 16px',
//               border: '1px solid #d1d5db',
//               borderRadius: '8px',
//               fontSize: '14px',
//               outline: 'none',
//               transition: 'all 0.2s',
//               boxSizing: 'border-box',
//               backgroundColor: 'white'
//             }}
//             onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
//             onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
//           />
//         </div>
//         <div>
//           <label style={{
//             display: 'block',
//             fontSize: '14px',
//             fontWeight: '600',
//             color: '#374151',
//             marginBottom: '8px'
//           }}>Search By</label>
//           <select
//             value={searchBy}
//             onChange={(e) => {
//               setSearchBy(e.target.value);
//               // Reset reportType based on new searchBy
//               const options = getReportTypeOptions();
//               setReportType(options.includes(reportType) ? reportType : options[0]);
//             }}
//             style={{
//               width: '100%',
//               padding: '12px 16px',
//               border: '1px solid #d1d5db',
//               borderRadius: '8px',
//               fontSize: '14px',
//               outline: 'none',
//               transition: 'all 0.2s',
//               backgroundColor: 'white',
//               cursor: 'pointer',
//               boxSizing: 'border-box'
//             }}
//             onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
//             onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
//           >
//             <option value="datewise">Datewise</option>
//             <option value="customer">Customerwise</option>
//             <option value="groupwise">Groupwise</option>
//             <option value="productwise">Productwise</option>

//           </select>
//         </div>
//         <div>
//           <label style={{
//             display: 'block',
//             fontSize: '14px',
//             fontWeight: '600',
//             color: '#374151',
//             marginBottom: '8px'
//           }}>Report Type</label>
//           <select
//             value={reportType}
//             onChange={(e) => setReportType(e.target.value)}
//             style={{
//               width: '100%',
//               padding: '12px 16px',
//               border: '1px solid #d1d5db',
//               borderRadius: '8px',
//               fontSize: '14px',
//               outline: 'none',
//               transition: 'all 0.2s',
//               backgroundColor: 'white',
//               cursor: 'pointer',
//               boxSizing: 'border-box'
//             }}
//             onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
//             onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
//           >
//             {getReportTypeOptions().map(option => (
//               <option key={option} value={option}>
//                 {option.charAt(0).toUpperCase() + option.slice(1)}
//               </option>
//             ))}
//           </select>
//         </div>
//       </div>

//       <div style={{
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
//         gap: '20px',
//         marginBottom: '32px'
//       }}>
//         {/* <FilterSection 
//           title="Stores" 
//           options={stores} 
//           selected={filters.store} 
//           onChange={(value) => handleFilterChange("store", value)}
//         /> */}
//         <FilterSection 
//           title="Customer" 
//           options={customers} 
//           selected={filters.customer} 
//           onChange={(value) => handleFilterChange("customer", value)}
//         />
//         <FilterSection 
//           title="Group Name" 
//           options={groups} 
//           selected={filters.group} 
//           onChange={(value) => handleFilterChange("group", value)}
//         />
//         <FilterSection 
//           title="Category" 
//           options={categories} 
//           selected={filters.category} 
//           onChange={(value) => handleFilterChange("category", value)}
//         />
//         <FilterSection 
//           title="Brand" 
//           options={brands} 
//           selected={filters.brand} 
//           onChange={(value) => handleFilterChange("brand", value)}
//         />
//         <FilterSection 
//           title="Product" 
//           options={products} 
//           selected={filters.product} 
//           onChange={(value) => handleFilterChange("product", value)}
//         />
//       </div>

//       <div style={{ 
//         display: 'flex', 
//         gap: '16px', 
//         marginBottom: '32px',
//         justifyContent: 'center'
//       }}>
//         <button
//           onClick={handleGenerateReport}
//           style={{
//             background: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
//             color: 'white',
//             padding: '12px 24px',
//             borderRadius: '8px',
//             border: 'none',
//             cursor: 'pointer',
//             transition: 'all 0.3s',
//             fontSize: '16px',
//             fontWeight: '600',
//             display: 'inline-flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             minWidth: '140px',
//             boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
//           }}
//           onMouseEnter={(e) => {
//             e.currentTarget.style.transform = 'translateY(-2px)';
//             e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
//           }}
//           onMouseLeave={(e) => {
//             e.currentTarget.style.transform = 'translateY(0)';
//             e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
//           }}
//         >
//           Generate Report
//         </button>
//         <button
//           onClick={handlePrint}
//           style={{
//             background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
//             color: 'white',
//             padding: '12px 24px',
//             borderRadius: '8px',
//             border: 'none',
//             cursor: 'pointer',
//             transition: 'all 0.3s',
//             fontSize: '16px',
//             fontWeight: '600',
//             display: 'inline-flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             minWidth: '120px',
//             boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
//           }}
//           onMouseEnter={(e) => {
//             e.currentTarget.style.transform = 'translateY(-2px)';
//             e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
//           }}
//           onMouseLeave={(e) => {
//             e.currentTarget.style.transform = 'translateY(0)';
//             e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
//           }}
//         >
//           Print Report
//         </button>
//       </div>

//       {showReport && (
//         <SalesReturnReportDisplay 
//           formData={formData}
//           filters={filters}
//           branchProfile={branchProfile}
//           salesReturnData={salesReturnData}
//         />
//       )}
//     </div>
//   );
// };

// export default SalesReturnReport;

import React, { useState, useEffect } from 'react';
import { database, auth } from '../firebase';
import { ref, onValue, off } from 'firebase/database';
import { onAuthStateChanged } from 'firebase/auth';
import ReactDOMServer from 'react-dom/server';

// Helper: Extract city from address
const getCityFromAddress = (address) => {
  if (!address) return 'Unknown City';
  const addressParts = address.trim().split(/\s+/);
  return addressParts.length > 0 ? addressParts[addressParts.length - 1] : 'Unknown City';
};

// Filter Section Component
const FilterSection = ({ title, options, selected, onChange }) => {
  const handleCheckboxChange = (option) => {
    if (option === options[0]) {
      onChange(selected.includes(option) ? [] : [...options]);
    } else {
      const newSelected = selected.includes(option)
        ? selected.filter(item => item !== option && item !== options[0])
        : [...selected.filter(item => item !== options[0]), option];
      onChange(newSelected.length === options.length - 1 ? [options[0], ...newSelected] : newSelected);
    }
  };

  return (
    <div style={{
      backgroundColor: '#f8fafc',
      padding: '16px',
      borderRadius: '8px',
      border: '1px solid #e2e8f0',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
      transition: 'all 0.3s ease',
      maxWidth: '220px',
      marginBottom: '16px',
    }}>
      <h2 style={{
        fontSize: '16px',
        fontWeight: '600',
        color: '#1e293b',
        marginBottom: '8px',
        borderBottom: '2px solid #3b82f6',
        paddingBottom: '6px',
      }}>{title}</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {options.map((option) => (
          <label key={option} style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            cursor: 'pointer',
            padding: '6px',
            borderRadius: '6px',
            transition: 'background-color 0.2s',
            backgroundColor: selected.includes(option) ? '#eff6ff' : 'transparent',
          }}
          onMouseEnter={(e) => !selected.includes(option) && (e.currentTarget.style.backgroundColor = '#f1f5f9')}
          onMouseLeave={(e) => !selected.includes(option) && (e.currentTarget.style.backgroundColor = 'transparent')}>
            <input
              type="checkbox"
              checked={selected.includes(option)}
              onChange={() => handleCheckboxChange(option)}
              style={{
                height: '14px',
                width: '14px',
                accentColor: '#3b82f6',
                cursor: 'pointer',
              }}
            />
            <span style={{ 
              fontSize: '14px',
              color: '#475569',
              userSelect: 'none',
              fontWeight: selected.includes(option) ? '500' : '400',
            }}>{option}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

// Sales Return Report Display Component
const SalesReturnReportDisplay = ({ formData, filters, branchProfile, salesReturnData }) => {
  const parseReturnDate = (dateString) => {
    if (!dateString) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      const parts = dateString.split('-');
      return new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    }
    if (/^\d{2}[-\/]\d{2}[-\/]\d{4}$/.test(dateString)) {
      const parts = dateString.split(/[-\/]/);
      return new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
    }
    return new Date(dateString);
  };

  const formatDisplayDate = (dateString) => {
    const date = parseReturnDate(dateString);
    return !date || isNaN(date.getTime()) ? 'N/A' : date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  let filteredSalesReturnData = salesReturnData;

  if (!filters.store.includes("All Stores")) {
    filteredSalesReturnData = filteredSalesReturnData.filter(item => filters.store.includes(item.store));
  }
  if (!filters.customer.includes("All Customers")) {
    filteredSalesReturnData = filteredSalesReturnData.filter(item => filters.customer.includes(item.customer));
  }
  if (!filters.group.includes("All Group Names")) {
    filteredSalesReturnData = filteredSalesReturnData.filter(item => filters.group.includes(item.groupName));
  }
  if (!filters.category.includes("All Categories")) {
    filteredSalesReturnData = filteredSalesReturnData.filter(item => filters.category.includes(item.category));
  }
  if (!filters.brand.includes("All Brands")) {
    filteredSalesReturnData = filteredSalesReturnData.filter(item => filters.brand.includes(item.brand));
  }
  if (!filters.product.includes("All Products")) {
    filteredSalesReturnData = filteredSalesReturnData.filter(item => filters.product.includes(item.itemDescription));
  }

  const filterByDateRange = (data) => {
    return data.filter(item => {
      const itemDate = parseReturnDate(item.srnDate);
      if (!itemDate || isNaN(itemDate.getTime())) return false;
      const fromDate = new Date(formData.fromDate);
      const toDate = new Date(formData.toDate);
      toDate.setHours(23, 59, 59, 999);
      return itemDate >= fromDate && itemDate <= toDate;
    });
  };

  const getReportTitle = () => {
    switch (formData.searchBy) {
      case "datewise": return "Datewise Sales Return Report";
      case "store": return "Store-wise Sales Return Report";
      case "customer": return "Customerwise Sales Return Report";
      case "salesmanwise": return "SalesRep wise Sales Return Report";
      case "groupwise": return "Groupwise Sales Return Report";
      case "category": return "Category-wise Sales Return Report";
      case "brand": return "Brand-wise Sales Return Report";
      case "productwise": return "Product-wise Sales Return Report";
      default: return "Datewise Sales Return Report";
    }
  };

  const city = branchProfile.city || getCityFromAddress(branchProfile.address);

  const dateFilteredData = filterByDateRange(filteredSalesReturnData);

  const renderDetailedReport = () => {
    if (formData.searchBy === "datewise") {
      const grandTotal = dateFilteredData.reduce((sum, item) => sum + item.totalValue, 0);
      return (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ 
            width: '100%', 
            borderCollapse: 'collapse', 
            fontSize: '11px', 
            border: '2px solid #3b82f6',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }} className="datewise-detailed">
            <thead>
              <tr style={{ backgroundColor: '#f1f5f9', borderBottom: '2px solid #3b82f6' }}>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>S.No</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Inv.No</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Inv.Dt</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Customer</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Product Name</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Return Qty</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Rate</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Gross Amnt</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Disc Amnt</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>CGST Amnt</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>SGST Amnt</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>GST Amnt</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Net Value</th>
              </tr>
            </thead>
            <tbody>
              {dateFilteredData.length === 0 ? (
                <tr>
                  <td colSpan="13" style={{ 
                    border: '1px solid #cbd5e1', 
                    padding: '30px', 
                    textAlign: 'center', 
                    color: '#64748b', 
                    fontStyle: 'italic',
                    fontSize: '14px',
                    backgroundColor: '#f8fafc'
                  }}>
                    No sales return data found for the selected criteria
                  </td>
                </tr>
              ) : (
                <>
                  {dateFilteredData.map((item, index) => (
                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{index + 1}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{item.srnNo}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{formatDisplayDate(item.srnDate)}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'left', fontSize: '11px' }}>{item.customer}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'left', fontSize: '11px' }}>{item.itemDescription}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{item.returnQty || item.qty}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.mrp.toFixed(2)}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{(item.returnQty * item.mrp).toFixed(2)}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.discount.toFixed(2)}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.cgstTax.toFixed(2)}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.sgstTax.toFixed(2)}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{(item.cgstTax + item.sgstTax).toFixed(2)}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.totalValue.toFixed(2)}</td>
                    </tr>
                  ))}
                  <tr style={{ backgroundColor: '#f1f5f9', fontWeight: '600' }}>
                    <td colSpan="12" style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>Bill Grand Total:</td>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{grandTotal.toFixed(2)}</td>
                  </tr>
                  <tr style={{ backgroundColor: '#f1f5f9', fontWeight: '600' }}>
                    <td colSpan="12" style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>Total:</td>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{grandTotal.toFixed(2)}</td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (formData.searchBy === "customer") {
      const grandTotal = dateFilteredData.reduce((sum, item) => sum + item.totalValue, 0);
      return (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ 
            width: '100%', 
            borderCollapse: 'collapse', 
            fontSize: '11px', 
            border: '2px solid #3b82f6',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }} className="customer-detailed">
            <thead>
              <tr style={{ backgroundColor: '#f1f5f9', borderBottom: '2px solid #3b82f6' }}>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>S.No</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>INV.No</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>INV.Dt</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Gross Amnt</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Disc Amnt</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>CGST Amnt</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>SGST Amnt</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>GST Amnt</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Others</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Net Value</th>
              </tr>
            </thead>
            <tbody>
              {dateFilteredData.length === 0 ? (
                <tr>
                  <td colSpan="10" style={{ 
                    border: '1px solid #cbd5e1', 
                    padding: '30px', 
                    textAlign: 'center', 
                    color: '#64748b', 
                    fontStyle: 'italic',
                    fontSize: '14px',
                    backgroundColor: '#f8fafc'
                  }}>
                    No sales return data found for the selected criteria
                  </td>
                </tr>
              ) : (
                <>
                  {dateFilteredData.map((item, index) => (
                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{index + 1}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{item.srnNo}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{formatDisplayDate(item.srnDate)}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{(item.returnQty * item.mrp).toFixed(2)}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.discount.toFixed(2)}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.cgstTax.toFixed(2)}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.sgstTax.toFixed(2)}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{(item.cgstTax + item.sgstTax).toFixed(2)}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹0.00</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.totalValue.toFixed(2)}</td>
                    </tr>
                  ))}
                  <tr style={{ backgroundColor: '#f1f5f9', fontWeight: '600' }}>
                    <td colSpan="9" style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>Bill Grand Total:</td>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{grandTotal.toFixed(2)}</td>
                  </tr>
                  <tr style={{ backgroundColor: '#f1f5f9', fontWeight: '600' }}>
                    <td colSpan="9" style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>Total:</td>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{grandTotal.toFixed(2)}</td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
      );
    } else if (formData.searchBy === "salesmanwise") {
      const grandTotal = dateFilteredData.reduce((sum, item) => sum + item.totalValue, 0);
      return (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ 
            width: '100%', 
            borderCollapse: 'collapse', 
            fontSize: '11px', 
            border: '2px solid #3b82f6',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }} className="salesmanwise-detailed">
            <thead>
              <tr style={{ backgroundColor: '#f1f5f9', borderBottom: '2px solid #3b82f6' }}>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>S.No</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>INV.No</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>INV.Dt</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Customer Name</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Gross Amt</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Disc.Amt</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>CGST Amnt</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>SGST Amnt</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>GST Amnt</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Others</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Net Value</th>
              </tr>
            </thead>
            <tbody>
              {dateFilteredData.length === 0 ? (
                <tr>
                  <td colSpan="11" style={{ 
                    border: '1px solid #cbd5e1', 
                    padding: '30px', 
                    textAlign: 'center', 
                    color: '#64748b', 
                    fontStyle: 'italic',
                    fontSize: '14px',
                    backgroundColor: '#f8fafc'
                  }}>
                    No sales return data found for the selected criteria
                  </td>
                </tr>
              ) : (
                <>
                  {dateFilteredData.map((item, index) => (
                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{index + 1}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{item.srnNo}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{formatDisplayDate(item.srnDate)}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'left', fontSize: '11px' }}>{item.customer}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{(item.returnQty * item.mrp).toFixed(2)}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.discount.toFixed(2)}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.cgstTax.toFixed(2)}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.sgstTax.toFixed(2)}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{(item.cgstTax + item.sgstTax).toFixed(2)}</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹0.00</td>
                      <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.totalValue.toFixed(2)}</td>
                    </tr>
                  ))}
                  <tr style={{ backgroundColor: '#f1f5f9', fontWeight: '600' }}>
                    <td colSpan="10" style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>Bill Grand Total:</td>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{grandTotal.toFixed(2)}</td>
                  </tr>
                  <tr style={{ backgroundColor: '#f1f5f9', fontWeight: '600' }}>
                    <td colSpan="10" style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>Total:</td>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{grandTotal.toFixed(2)}</td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
      );
    }
  };

  const renderAbstractReport = () => {
    if (formData.searchBy === "groupwise") {
      const groupedData = dateFilteredData.reduce((acc, item) => {
        const groupName = item.groupName || 'No Group Assigned';
        if (!acc[groupName]) {
          acc[groupName] = { groupName, value: 0, discount: 0, gstValue: 0, netValue: 0 };
        }
        acc[groupName].value += item.value;
        acc[groupName].discount += item.discount;
        acc[groupName].gstValue += (item.cgstTax + item.sgstTax);
        acc[groupName].netValue += item.totalValue;
        return acc;
      }, {});

      const groupedArray = Object.values(groupedData);

      return (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ 
            width: '100%', 
            borderCollapse: 'collapse', 
            fontSize: '11px', 
            border: '2px solid #3b82f6',
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}>
            <thead>
              <tr style={{ backgroundColor: '#f1f5f9', borderBottom: '2px solid #3b82f6' }}>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>S.No</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Group Name</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Value</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Disc.</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>GST Value</th>
                <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px' }}>Net Value</th>
              </tr>
            </thead>
            <tbody>
              {groupedArray.length === 0 ? (
                <tr>
                  <td colSpan="6" style={{ 
                    border: '1px solid #cbd5e1', 
                    padding: '30px', 
                    textAlign: 'center', 
                    color: '#64748b', 
                    fontStyle: 'italic',
                    fontSize: '14px',
                    backgroundColor: '#f8fafc'
                  }}>
                    No Record Found.
                  </td>
                </tr>
              ) : (
                groupedArray.map((item, index) => (
                  <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '11px' }}>{index + 1}</td>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'left', fontSize: '11px' }}>{item.groupName}</td>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.value.toFixed(2)}</td>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.discount.toFixed(2)}</td>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.gstValue.toFixed(2)}</td>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'right', fontSize: '11px' }}>₹{item.netValue.toFixed(2)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      );
    }
  };

  return (
    <div style={{
      backgroundColor: 'white',
      padding: '30px',
      marginTop: '20px',
      border: '2px solid #3b82f6',
      borderRadius: '12px',
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
      pageBreakInside: 'avoid',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
    }} className="print-only">
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'flex-start', 
        marginBottom: '30px',
        paddingBottom: '20px',
        borderBottom: '2px solid #e2e8f0'
      }}>
        <div style={{ flex: 1 }}>
          <h1 style={{ 
            fontSize: '24px', 
            fontWeight: 'bold', 
            margin: '0', 
            marginBottom: '15px',
            color: '#1e293b',
            textShadow: '1px 1px 2px rgba(0,0,0,0.1)'
          }}>
            {branchProfile.branchName}
          </h1>
          <div style={{ fontSize: '14px', lineHeight: '1.6', color: '#475569' }}>
            <div style={{ marginBottom: '8px', fontSize: '16px', fontWeight: '600', color: '#3b82f6' }}>
              {getReportTitle()}
            </div>
            <div style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
              <span><strong>From:</strong> {new Date(formData.fromDate).toLocaleDateString('en-GB')}</span>
              <span><strong>To:</strong> {new Date(formData.toDate).toLocaleDateString('en-GB')}</span>
            </div>
          </div>
        </div>
        <div style={{
          background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
          color: 'white',
          padding: '15px 25px',
          borderRadius: '15px',
          textAlign: 'center',
          minWidth: '150px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{city}</div>
          <div style={{ fontSize: '12px', marginTop: '5px', opacity: '0.9' }}>
            Option: {formData.reportType === 'detailed' ? 'Detail' : 'Abstract'}
          </div>
        </div>
      </div>
      {formData.reportType === 'detailed' ? renderDetailedReport() : renderAbstractReport()}
    </div>
  );
};

// Main Sales Return Report Generator Component
const SalesReturnReport = () => {
  const today = new Date();
  const [fromDate, setFromDate] = useState(today.toISOString().split('T')[0]);
  const [toDate, setToDate] = useState(today.toISOString().split('T')[0]);
  const [searchBy, setSearchBy] = useState("salesmanwise");
  const [reportType, setReportType] = useState("detailed");
  const [filters, setFilters] = useState({
    store: ["All Stores"],
    customer: ["All Customers"],
    group: ["All Group Names"],
    category: ["All Categories"],
    brand: ["All Brands"],
    product: ["All Products"]
  });
  const [stores, setStores] = useState(["All Stores"]);
  const [customers, setCustomers] = useState(["All Customers"]);
  const [groups, setGroups] = useState(["All Group Names"]);
  const [categories, setCategories] = useState(["All Categories"]);
  const [brands, setBrands] = useState(["All Brands"]);
  const [products, setProducts] = useState(["All Products"]);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showReport, setShowReport] = useState(false);
  const [branchProfile, setBranchProfile] = useState({
    branchName: "SUPREME TRADERS",
    address: "",
    phone: "",
    city: ""
  });
  const [salesReturnData, setSalesReturnData] = useState([]);
  const [productGroupMap, setProductGroupMap] = useState({});
  const [productCategoryMap, setProductCategoryMap] = useState({});
  const [productBrandMap, setProductBrandMap] = useState({});

  const encodeEmailForPath = (email) => {
    return email.replace(/[.#$[\]]/g, '_');
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      if (user) loadFirebaseData(user);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const loadFirebaseData = (user) => {
    const encodedEmail = encodeEmailForPath(user.email);

    const branchProfileRef = ref(database, `users/${encodedEmail}/branchProfiles`);
    onValue(branchProfileRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const profiles = Object.values(data);
        const latestProfile = profiles[profiles.length - 1];
        setBranchProfile({
          branchName: latestProfile.branchName || "SUPREME TRADERS",
          address: `${latestProfile.address1 || ''} ${latestProfile.address2 || ''}`.trim(),
          phone: latestProfile.mobileNo || '',
          city: latestProfile.city || getCityFromAddress(`${latestProfile.address1 || ''} ${latestProfile.address2 || ''}`)
        });
      }
    });

    const storesRef = ref(database, `users/${encodedEmail}/stores`);
    onValue(storesRef, (snapshot) => {
      const storesData = ["All Stores"];
      if (snapshot.exists()) snapshot.forEach((childSnapshot) => {
        const store = childSnapshot.val();
        if (store.name && !storesData.includes(store.name)) storesData.push(store.name);
      });
      setStores(storesData);
    });

    const customersRef = ref(database, `users/${encodedEmail}/customers`);
    onValue(customersRef, (snapshot) => {
      const customersData = ["All Customers"];
      if (snapshot.exists()) snapshot.forEach((childSnapshot) => {
        const customer = childSnapshot.val();
        if (customer.customerName && !customersData.includes(customer.customerName)) customersData.push(customer.customerName);
      });
      setCustomers(customersData);
    });

    const groupsRef = ref(database, `users/${encodedEmail}/productGroups`);
    onValue(groupsRef, (snapshot) => {
      const groupsData = ["All Group Names"];
      if (snapshot.exists()) snapshot.forEach((childSnapshot) => {
        const group = childSnapshot.val();
        if (group.name && !groupsData.includes(group.name)) groupsData.push(group.name);
      });
      setGroups(groupsData);
    });

    const categoriesRef = ref(database, `users/${encodedEmail}/categories`);
    onValue(categoriesRef, (snapshot) => {
      const categoriesData = ["All Categories"];
      if (snapshot.exists()) snapshot.forEach((childSnapshot) => {
        const category = childSnapshot.val();
        if (category.name && !categoriesData.includes(category.name)) categoriesData.push(category.name);
      });
      setCategories(categoriesData);
    });

    const brandsRef = ref(database, `users/${encodedEmail}/brands`);
    onValue(brandsRef, (snapshot) => {
      const brandsData = ["All Brands"];
      if (snapshot.exists()) snapshot.forEach((childSnapshot) => {
        const brand = childSnapshot.val();
        if (brand.name && !brandsData.includes(brand.name)) brandsData.push(brand.name);
      });
      setBrands(brandsData);
    });

    const productsRef = ref(database, `users/${encodedEmail}/products`);
    onValue(productsRef, (snapshot) => {
      const productsData = ["All Products"];
      const groupMap = {};
      const categoryMap = {};
      const brandMap = {};
      if (snapshot.exists()) snapshot.forEach((childSnapshot) => {
        const product = childSnapshot.val();
        if (product.productName && !productsData.includes(product.productName)) {
          productsData.push(product.productName);
          groupMap[product.productName] = product.groupName || product.group || 'No Group Assigned';
          categoryMap[product.productName] = product.category || 'Unknown Category';
          brandMap[product.productName] = product.brand || 'Unknown Brand';
        }
      });
      setProducts(productsData);
      setProductGroupMap(groupMap);
      setProductCategoryMap(categoryMap);
      setProductBrandMap(brandMap);
    });

    const salesReturnsRef = ref(database, `users/${encodedEmail}/salesReturns`);
    onValue(salesReturnsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const returnRecords = [];
        Object.entries(data).forEach(([returnId, returnData]) => {
          if (returnData.items && Array.isArray(returnData.items)) {
            returnData.items.forEach(item => {
              if (item.itemDescription) {
                const returnQty = parseFloat(item.returnQty) || parseFloat(item.qty) || 0;
                const mrp = parseFloat(item.mrp) || 0;
                const discPercent = parseFloat(item.disc) || 0;
                const cgstRate = parseFloat(item.cgst) || 0;
                const sgstRate = parseFloat(item.sgst) || 0;
                const baseAmount = returnQty * mrp;
                const discount = (baseAmount * discPercent) / 100;
                const value = baseAmount - discount;
                const cgstTax = (value * cgstRate) / 100;
                const sgstTax = (value * sgstRate) / 100;
                const totalValue = value + cgstTax + sgstTax;

                returnRecords.push({
                  returnId,
                  srnNo: returnData.srnNo || 'N/A',
                  srnDate: returnData.srnDate || '',
                  billNo: returnData.billNo || 'N/A',
                  store: returnData.store || 'Unknown Store',
                  customer: returnData.customer || 'Unknown Customer',
                  itemDescription: item.itemDescription || 'Unknown Product',
                  groupName: productGroupMap[item.itemDescription] || 'No Group Assigned',
                  category: productCategoryMap[item.itemDescription] || 'Unknown Category',
                  brand: productBrandMap[item.itemDescription] || 'Unknown Brand',
                  barCode: item.barCode || '',
                  uom: item.uom || '',
                  qty: parseFloat(item.qty) || 0,
                  returnQty: returnQty,
                  mrp,
                  value,
                  discount,
                  cgstTax,
                  sgstTax,
                  totalValue
                });
              }
            });
          }
        });
        setSalesReturnData(returnRecords);
      } else {
        setSalesReturnData([]);
      }
    });

    return () => {
      off(branchProfileRef);
      off(storesRef);
      off(customersRef);
      off(groupsRef);
      off(categoriesRef);
      off(brandsRef);
      off(productsRef);
      off(salesReturnsRef);
    };
  };

  useEffect(() => {
    if (Object.keys(productGroupMap).length > 0 && currentUser) {
      setSalesReturnData(prevData => 
        prevData.map(item => ({
          ...item,
          groupName: productGroupMap[item.itemDescription] || 'No Group Assigned',
          category: productCategoryMap[item.itemDescription] || 'Unknown Category',
          brand: productBrandMap[item.itemDescription] || 'Unknown Brand'
        }))
      );
    }
  }, [productGroupMap, productCategoryMap, productBrandMap, currentUser]);

  const handleFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value });
  };

  const handleGenerateReport = () => {
    setShowReport(true);
  };

  const handlePrint = () => {
    const printContent = (
      <SalesReturnReportDisplay 
        formData={{ fromDate, toDate, searchBy, reportType }}
        filters={filters}
        branchProfile={branchProfile}
        salesReturnData={salesReturnData}
      />
    );

    const htmlString = ReactDOMServer.renderToString(printContent);

    const printWindow = window.open('', '', 'width=1200,height=800');
    printWindow.document.write(`
      <html>
        <head>
          <title>Sales Return Report</title>
          <style>
            body { 
              margin: 0; 
              padding: 5px; 
              font-family: Arial, sans-serif; 
              font-size: 8px;
            }
            @page { 
              size: A4 landscape; 
              margin: 5mm; 
            }
            table { 
              page-break-inside: auto;
              width: 100%;
              font-size: 7px;
              table-layout: fixed;
              border-collapse: collapse;
            }
            tr { 
              page-break-inside: avoid; 
              page-break-after: auto; 
            }
            th, td {
              padding: 4px !important;
              font-size: 12px !important;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 60px;
            }
            /* Datewise detailed columns */
            .datewise-detailed th:nth-child(1), .datewise-detailed td:nth-child(1) { width: 25px; } /* S.No */
            .datewise-detailed th:nth-child(2), .datewise-detailed td:nth-child(2) { width: 45px; } /* Inv No */
            .datewise-detailed th:nth-child(3), .datewise-detailed td:nth-child(3) { width: 40px; } /* Date */
            .datewise-detailed th:nth-child(4), .datewise-detailed td:nth-child(4) { width: 60px; } /* Customer */
            .datewise-detailed th:nth-child(5), .datewise-detailed td:nth-child(5) { width: 80px; } /* Product */
            .datewise-detailed th:nth-child(6), .datewise-detailed td:nth-child(6) { width: 30px; } /* Return Qty */
            .datewise-detailed th:nth-child(7), .datewise-detailed td:nth-child(7) { width: 35px; } /* Rate */
            .datewise-detailed th:nth-child(8), .datewise-detailed td:nth-child(8) { width: 40px; } /* Gross */
            .datewise-detailed th:nth-child(9), .datewise-detailed td:nth-child(9) { width: 40px; } /* Disc */
            .datewise-detailed th:nth-child(10), .datewise-detailed td:nth-child(10) { width: 40px; } /* CGST */
            .datewise-detailed th:nth-child(11), .datewise-detailed td:nth-child(11) { width: 40px; } /* SGST */
            .datewise-detailed th:nth-child(12), .datewise-detailed td:nth-child(12) { width: 40px; } /* GST */
            .datewise-detailed th:nth-child(13), .datewise-detailed td:nth-child(13) { width: 50px; } /* Net Value */
            /* Customer detailed columns */
            .customer-detailed th:nth-child(1), .customer-detailed td:nth-child(1) { width: 30px; } /* S.No */
            .customer-detailed th:nth-child(2), .customer-detailed td:nth-child(2) { width: 50px; } /* INV No */
            .customer-detailed th:nth-child(3), .customer-detailed td:nth-child(3) { width: 45px; } /* Date */
            .customer-detailed th:nth-child(4), .customer-detailed td:nth-child(4) { width: 50px; } /* Gross */
            .customer-detailed th:nth-child(5), .customer-detailed td:nth-child(5) { width: 45px; } /* Disc */
            .customer-detailed th:nth-child(6), .customer-detailed td:nth-child(6) { width: 45px; } /* CGST */
            .customer-detailed th:nth-child(7), .customer-detailed td:nth-child(7) { width: 45px; } /* SGST */
            .customer-detailed th:nth-child(8), .customer-detailed td:nth-child(8) { width: 45px; } /* GST */
            .customer-detailed th:nth-child(9), .customer-detailed td:nth-child(9) { width: 40px; } /* Others */
            .customer-detailed th:nth-child(10), .customer-detailed td:nth-child(10) { width: 55px; } /* Net Value */
            /* Salesmanwise detailed columns */
            .salesmanwise-detailed th:nth-child(1), .salesmanwise-detailed td:nth-child(1) { width: 25px; } /* S.No */
            .salesmanwise-detailed th:nth-child(2), .salesmanwise-detailed td:nth-child(2) { width: 45px; } /* INV No */
            .salesmanwise-detailed th:nth-child(3), .salesmanwise-detailed td:nth-child(3) { width: 40px; } /* Date */
            .salesmanwise-detailed th:nth-child(4), .salesmanwise-detailed td:nth-child(4) { width: 60px; } /* Customer */
            .salesmanwise-detailed th:nth-child(5), .salesmanwise-detailed td:nth-child(5) { width: 45px; } /* Gross */
            .salesmanwise-detailed th:nth-child(6), .salesmanwise-detailed td:nth-child(6) { width: 40px; } /* Disc */
            .salesmanwise-detailed th:nth-child(7), .salesmanwise-detailed td:nth-child(7) { width: 40px; } /* CGST */
            .salesmanwise-detailed th:nth-child(8), .salesmanwise-detailed td:nth-child(8) { width: 40px; } /* SGST */
            .salesmanwise-detailed th:nth-child(9), .salesmanwise-detailed td:nth-child(9) { width: 40px; } /* GST */
            .salesmanwise-detailed th:nth-child(10), .salesmanwise-detailed td:nth-child(10) { width: 35px; } /* Others */
            .salesmanwise-detailed th:nth-child(11), .salesmanwise-detailed td:nth-child(11) { width: 50px; } /* Net Value */
            /* Groupwise abstract columns */
            .groupwise-abstract th:nth-child(1), .groupwise-abstract td:nth-child(1) { width: 30px; } /* S.No */
            .groupwise-abstract th:nth-child(2), .groupwise-abstract td:nth-child(2) { width: 120px; } /* Group */
            .groupwise-abstract th:nth-child(3), .groupwise-abstract td:nth-child(3) { width: 50px; } /* Value */
            .groupwise-abstract th:nth-child(4), .groupwise-abstract td:nth-child(4) { width: 45px; } /* Disc */
            .groupwise-abstract th:nth-child(5), .groupwise-abstract td:nth-child(5) { width: 50px; } /* GST Value */
            .groupwise-abstract th:nth-child(6), .groupwise-abstract td:nth-child(6) { width: 60px; } /* Net Value */
            .print-only {
              width: 93% !important;
              max-width: none !important;
              overflow: visible !important;
            }
            div[style*="overflowX"] {
              overflow: visible !important;
            }
          </style>
        </head>
        <body>
          <div id="print-content">${htmlString}</div>
          <script>
            setTimeout(function() {
              window.print();
              window.close();
            }, 1000);
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  const formData = {
    fromDate,
    toDate,
    searchBy,
    reportType
  };

  const getReportTypeOptions = () => {
    switch (searchBy) {
      case "groupwise":
      case "productwise":
        return ["abstract"];
      case "customer":
      case "datewise":
      case "salesmanwise":
        return ["detailed", "abstract"];
      default:
        return ["detailed", "abstract"];
    }
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '400px',
        fontSize: '18px',
        color: '#64748b',
        backgroundColor: '#f8fafc',
        borderRadius: '12px',
        border: '1px solid #e2e8f0'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            width: '40px', 
            height: '40px', 
            border: '4px solid #e2e8f0',
            borderTop: '4px solid #3b82f6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }}></div>
          <div>Loading Sales Return Data...</div>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '3rem', 
        color: '#64748b', 
        fontSize: '18px',
        backgroundColor: '#f8fafc',
        borderRadius: '12px',
        border: '1px solid #e2e8f0'
      }}>
        <h2 style={{ color: '#1e293b', marginBottom: '16px' }}>Authentication Required</h2>
        <p>Please login to access the Sales Return Report </p>
      </div>
    );
  }

  return (
    <div style={{
      width: '100%',
      maxWidth: '90rem',
      backgroundColor: 'white',
      borderRadius: '16px',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      padding: '32px',
      margin: '0 auto',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      border: '1px solid #e2e8f0'
    }}>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '12px',
        marginBottom: '24px',
        paddingBottom: '16px',
        borderBottom: '2px solid #e2e8f0'
      }}>
        <div style={{
          width: '6px',
          height: '32px',
          backgroundColor: '#3b82f6',
          borderRadius: '3px'
        }}></div>
        <h1 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: '#1e293b',
          margin: '0'
        }}>Sales Return Report </h1>
      </div>
      
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '20px',
        marginBottom: '32px',
        padding: '24px',
        backgroundColor: '#f8fafc',
        borderRadius: '12px',
        border: '1px solid #e2e8f0'
      }}>
        <div>
          <label style={{
            display: 'block',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
            marginBottom: '8px'
          }}>From Date</label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              fontSize: '14px',
              outline: 'none',
              transition: 'all 0.2s',
              boxSizing: 'border-box',
              backgroundColor: 'white'
            }}
            onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
            onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
          />
        </div>
        <div>
          <label style={{
            display: 'block',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
            marginBottom: '8px'
          }}>To Date</label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              fontSize: '14px',
              outline: 'none',
              transition: 'all 0.2s',
              boxSizing: 'border-box',
              backgroundColor: 'white'
            }}
            onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
            onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
          />
        </div>
        <div>
          <label style={{
            display: 'block',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
            marginBottom: '8px'
          }}>Search By</label>
          <select
            value={searchBy}
            onChange={(e) => {
              setSearchBy(e.target.value);
              const options = getReportTypeOptions();
              setReportType(options.includes(reportType) ? reportType : options[0]);
            }}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              fontSize: '14px',
              outline: 'none',
              transition: 'all 0.2s',
              backgroundColor: 'white',
              cursor: 'pointer',
              boxSizing: 'border-box'
            }}
            onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
            onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
          >
            <option value="datewise">Datewise</option>
            <option value="customer">Customerwise</option>
            <option value="groupwise">Groupwise</option>
            <option value="productwise">Productwise</option>
          </select>
        </div>
        <div>
          <label style={{
            display: 'block',
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
            marginBottom: '8px'
          }}>Report Type</label>
          <select
            value={reportType}
            onChange={(e) => setReportType(e.target.value)}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              fontSize: '14px',
              outline: 'none',
              transition: 'all 0.2s',
              backgroundColor: 'white',
              cursor: 'pointer',
              boxSizing: 'border-box'
            }}
            onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
            onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
          >
            {getReportTypeOptions().map(option => (
              <option key={option} value={option}>
                {option.charAt(0).toUpperCase() + option.slice(1)}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: '20px',
        marginBottom: '32px'
      }}>
        <FilterSection 
          title="Customer" 
          options={customers} 
          selected={filters.customer} 
          onChange={(value) => handleFilterChange("customer", value)}
        />
        <FilterSection 
          title="Group Name" 
          options={groups} 
          selected={filters.group} 
          onChange={(value) => handleFilterChange("group", value)}
        />
        <FilterSection 
          title="Category" 
          options={categories} 
          selected={filters.category} 
          onChange={(value) => handleFilterChange("category", value)}
        />
        <FilterSection 
          title="Brand" 
          options={brands} 
          selected={filters.brand} 
          onChange={(value) => handleFilterChange("brand", value)}
        />
        <FilterSection 
          title="Product" 
          options={products} 
          selected={filters.product} 
          onChange={(value) => handleFilterChange("product", value)}
        />
      </div>

      <div style={{ 
        display: 'flex', 
        gap: '16px', 
        marginBottom: '32px',
        justifyContent: 'center'
      }}>
        <button
          onClick={handleGenerateReport}
          style={{
            background: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '8px',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s',
            fontSize: '16px',
            fontWeight: '600',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '140px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
          }}
        >
          Generate Report
        </button>
        <button
          onClick={handlePrint}
          style={{
            background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '8px',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s',
            fontSize: '16px',
            fontWeight: '600',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '120px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
          }}
        >
          Print Report
        </button>
      </div>

      {showReport && (
        <SalesReturnReportDisplay 
          formData={formData}
          filters={filters}
          branchProfile={branchProfile}
          salesReturnData={salesReturnData}
        />
      )}
    </div>
  );
};

export default SalesReturnReport;